var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Action.module.scss';
import { ArrowDown } from '../../assets/icons';
import { POSITION } from '../../constants';
import { ClickDetector } from '../ClickDetector/ClickDetector';
var Action = function (_a) {
    var children = _a.children, select = _a.select, icon = _a.icon, iconPosition = _a.iconPosition, label = _a.label, labelContent = _a.labelContent, noArrow = _a.noArrow, className = _a.className, id = _a.id, dataId = _a.dataId, dropdownClass = _a.dropdownClass, fluidHeight = _a.fluidHeight, controlled = _a.controlled, opened = _a.opened, onClick = _a.onClick, onDropdownChange = _a.onDropdownChange;
    var _b = useState(false), dropdownOpened = _b[0], setDropdownOpened = _b[1];
    var dropdownChange = function () {
        onDropdownChange === null || onDropdownChange === void 0 ? void 0 : onDropdownChange(!dropdownOpened);
        if (!controlled)
            setDropdownOpened(function (prev) { return !prev; });
    };
    var dropdownClose = function () {
        if (controlled)
            return onDropdownChange === null || onDropdownChange === void 0 ? void 0 : onDropdownChange(false);
        setDropdownOpened(false);
    };
    return (_jsxs("span", __assign({ className: "\n\t\t\t".concat(styles.Action, " ").concat(select ? styles.Select : '', " \n\t\t\t").concat(select && (opened || dropdownOpened) ? styles.Opened : '', " \n\t\t\t").concat(className ? className : ''), id: id, "data-testid": dataId, onClick: children ? dropdownChange : onClick }, { children: [icon && iconPosition === POSITION.LEFT && _jsx("span", __assign({ className: styles.Children }, { children: icon })), _jsxs("span", { children: [label, labelContent && _jsx("span", __assign({ className: styles.LabelContent }, { children: labelContent }))] }), icon && iconPosition === POSITION.RIGHT && _jsx("span", __assign({ className: styles.Children }, { children: icon })), children && (_jsxs(_Fragment, { children: [!noArrow && _jsx(ArrowDown, { className: styles.ArrowDown }), (opened || dropdownOpened) && (_jsx(ClickDetector, __assign({ onOutsideClick: dropdownClose, dataId: 'detector' }, { children: _jsx("section", __assign({ className: "".concat(styles.Dropdown, " ").concat(dropdownClass ? dropdownClass : '') }, { children: _jsx("section", __assign({ className: "".concat(styles.DropdownContent, " ").concat(fluidHeight ? styles.Fluid : '') }, { children: children })) })) })))] }))] })));
};
Action.propTypes = {
    label: PropTypes.string.isRequired,
    select: PropTypes.bool,
    noArrow: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    dropdownClass: PropTypes.string,
    fluidHeight: PropTypes.bool,
    controlled: PropTypes.bool,
    opened: PropTypes.bool,
    onClick: PropTypes.func,
    onDropdownChange: PropTypes.func,
    iconPosition: PropTypes.oneOf(['left', 'right']),
};
Action.defaultProps = {
    className: '',
    iconPosition: 'left',
};
export { Action };
//# sourceMappingURL=Action.js.map